import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';
import { Broll, Caption, VideoTheme } from '@t2c/ai-video-editor';
import { uuidv4 } from '@sdf/base';

interface Payload {
  id: string;
  brollData: {
    brollPercentage: number;
    brollClips: Broll[];
  };
  captionData: Caption[];
  videoData: {
    theme: VideoTheme;
  };
}

const updateBrollAndCaptionDraft = async (jsonData: Payload): Promise<any> => {
  const jsonObjectId = uuidv4();
  const preSignedUrlResponse = await axiosInstance.post('/api/s3/put-presigned-url', {
    format: 'video',
    uuid: jsonObjectId,
  });
  await fetch(preSignedUrlResponse.data, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(jsonData),
  });
  const res = await axiosInstance.put('/api/video/update-video', { objectId: jsonObjectId });
  return res.data;
};

export const useUpdateBrollAndCaptionDraft = () => {
  return useMutation(updateBrollAndCaptionDraft, { onSuccess: (data) => data });
};
